<template>
    <div class="cloud_page" ref="fullPage" @scroll="handleScroll">
        <div class="nav_box">
            <Nav :isClass="isClass" :active="1"></Nav>
        </div>
        <div class="banner">
            <div class="banner_title">金智云：一站式AI服务平台</div>
            <div class="banner_new">普惠 可信 合创</div>
        </div>
        <div class="card_box">
            <div class="card_item" v-for="(item, index) in cardList" :key="index">
                <div class="img_con"><img :src="item.url"></div>
                <div class="card_right_title">
                    <div class="card_title">{{ item.title }}</div>
                    <div class="card_conter">{{ item.conter }}</div>
                </div>
            </div>
        </div>
        <div class="popular">
            <div class="popular_title">
                <div class="popular_title_top">热门产品</div>
                <div class="popular_title_b">Popular resources</div>
            </div>
            <div class="popular_new_box">
                <div class="popular_new" :class="popularAct == index ? 'popular_act' : ''"
                    v-for="(item, index) in popularCardList" :key="index" @click="popuChange(index)">
                    <img :src="item.url">
                    <div class="popular_name">{{ item.name }}</div>
                </div>
            </div>
            <div class="popular_list_data">
                <template v-if="popularDataList">
                    <div class="popular_list_item" v-for="(item, index) in popularDataList" :key="index">
                        <div class="popular_list_item_title">{{ item.title }}</div>
                        <div class="popular_list_item_btn">一键部署</div>
                    </div>
                </template>

                <div class="no_expty" v-else>
                    <div class="no_expty_title">敬请期待</div>
                </div>
            </div>
        </div>
        <div class="capacity">
            <div class="capacity_card">
                <div class="capacity_left">
                    <img src="../assets/img/位图@2x (11).png">
                </div>
                <div class="capacity_right">
                    <div class="step">
                        <div class="primary" :class="capacityAct == 1 ? 'act' : ''"></div>
                        <div class="rectangle"></div>
                        <div class="primary" :class="capacityAct == 2 ? 'act' : ''"></div>
                        <div class="rectangle"></div>
                        <div class="primary" :class="capacityAct == 3 ? 'act' : ''"></div>
                    </div>
                    <div class="right_list">
                        <div class="right_item" v-for="(item, index) in capacityList" :key="index"
                            v-on:mouseover="capacityAct = index + 1" v-on:mouseout="capacityAct = 0">
                            <img :src="item.url"
                                :style="{ width: item.type ? '48px' : '', height: item.type ? '20px' : '' }">
                            <div class="right_item_title_box">
                                <div class="right_item_title">{{ item.title }}</div>
                                <div class="right_item_content">{{ item.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer_box">
            <div class="bg">
                <div class="popular_title">
                    <div class="popular_title_top">合作伙伴</div>
                    <div class="popular_title_b">Cooperation partners</div>
                </div>
                <div class="select_list_box">
                    <div class="select_item" v-for="(item, index) in footerList" :key="index">
                        <img :src="item.url" :style="{ width: item.width + 'px', height: item.height + 'px' }">
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="footer_fout"><Clas></Clas></div> -->
    </div>
</template>

<script>
import Nav from "../components/nav.vue";
export default {
    components: {
        Nav
    },
    data() {
        return {
            isClass: false,
            popularAct: 0,
            capacityAct: 0,
            cardList: [{
                url: require('../assets/img/位图@2x (3).png'),
                title: '算力租用',
                conter: '我们为您提供弹性的云端算力租用服务，让您的创新思维无需受限于硬件资源，高效驱动AI项目落地。'
            }, {
                url: require('../assets/img/位图@2x (4).png'),
                title: '模型开发',
                conter: '内置丰富的开发工具与组件库，一站式满足您从模型训练、调优到部署的全流程需求，助您快速打造专属的智能解决方案。'
            }, {
                url: require('../assets/img/位图@2x (5).png'),
                title: '模型仓库',
                conter: '汇聚海量优质预训练模型，为您解锁开箱即用的AI力量，显著提升研发效能与成果质量。'
            }, {
                url: require('../assets/img/位图@2x (6).png'),
                title: '模型应用',
                conter: '助力您将前沿的AI算法无缝融入业务流程，实现智能化升级，让算法发挥出最大价值，赋能各行各业，共筑智能未来。'
            }],
            popularCardList: [{
                url: require('../assets/img/位图@2x (7).png'),
                name:'算力卡'
            }, {
                url: require('../assets/img/位图@2x (8).png'),
                name:'镜像'
            }, {
                url: require('../assets/img/位图@2x (9).png'),
                name:'模型'
            }, {
                url: require('../assets/img/位图@2x (10).png'),
                name:'数据集'
            }],
            popularDataList: 
            [{ title: 'H100' },{ title: 'H800' },{ title: 'RTX 4090' },{ title: '昇腾 910B' },{ title: 'A30' },{ title: '曙光Z100L + K100L' }]
            ,
            capacityList: [
                {
                    url: require('../assets/img/位图 3@2x.png'),
                    title: '选择你的算力',
                    content: '注册后进入控制台，根据需求选择容器实例。'
                }, {
                    url: require('../assets/img/位图 4@2x.png'),
                    title: '选择系统/模型镜像',
                    content: '根据需求选择系统配置或者直接选择模型镜像。',
                    type: true
                }, {
                    url: require('../assets/img/位图 5@2x.png'),
                    title: '一键部署 开始使用',
                    // content: '注册后进入控制台，根据需求选择容器实例。'
                }
            ],
            footerList: [{
                url: require('../assets/img/位图@2x(7)(1).png'),
                width: 150,
                height: 58
            }, {
                url: require('../assets/img/位图@2x(8)(1).png'),
                width: 150,
                height: 46
            }, {
                url: require('../assets/img/位图@2x(9).png'),
                width: 150,
                height: 46
            }, {
                url: require('../assets/img/位图@2x (13).png'),
                width: 150,
                height: 46
            }, {
                url: require('../assets/img/位图@2x (14).png'),
                width: 150,
                height: 46
            }, {
                url: require('../assets/img/位图@2x (12).png'),
                width: 150,
                height: 46
            }]
        }
    },
    // 监听页面滚动
    mounted() {
        window.scrollTo(0, 0)
        let minWidth = window.screen.width;
        this.$refs["fullPage"].style.minWidth = minWidth + "px";
        window.addEventListener('scroll', this.mouseWheelHandle, true);
    },
    methods: {
        handleScroll() {
           

        },
        mouseWheelHandle() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if (scrollTop > 400) {
                this.isClass = true
            } else {
                this.isClass = false
            }
        },
        popuChange(index){
           this.popularAct = index
           if(index == 0){
            this.popularDataList = [{ title: 'H100' },{ title: 'H800' },{ title: 'RTX 4090' },{ title: '昇腾 910B' },{ title: 'A30' },{ title: '曙光Z100L + K100L' }]
           }
           if(index == 1){
            this.popularDataList = [{ title: 'H100' },{ title: 'H800' },{ title: 'RTX 4090' },{ title: '昇腾 910B' },{ title: 'A30' },{ title: '曙光Z100L + K100L' }]
           }
           if(index == 2){
            this.popularDataList = [{ title: '城市治理' },{title:'数字孪生'}]
           }
           if(index == 3){
            this.popularDataList = [{ title: '城市治理' },{title:'数字孪生'}]
           }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.mouseWheelHandle);
    },


}
</script>

<style lang="scss" scoped>
.cloud_page {
    position: relative;
    overflow: auto;
}

.nav_box {
    position: fixed;
    // position: sticky;
    top: 0;
    z-index: 99;
    width: 100%;
}

.banner {
    width: 100%;
    height: 700px;
    background-image: url("../assets/img/位图@2x (2).png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .banner_title {
        text-align: center;
        font-weight: 500;
        font-size: 28px;
        color: #FFFFFF;
        margin-bottom: 20px;
    }

    .banner_new {
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
    }
}

.card_box {
    position: absolute;
    top: 630px;
    display: flex;
    justify-content: space-evenly;

    .card_item {
        width: 20%;
        height: 110px;
        padding: 0 20px;
        background-color: #FFFFFF;
        box-shadow: 0px 1px 10px 0px rgba(0, 41, 134, 0.13);
        border-radius: 4px;
        display: flex;
        align-items: center;

        .img_con {
            margin-bottom: 12%;
            margin-right: 10px;

        }

        img {
            width: 30px;
            height: 38px;
        }

        .card_right_title {
            .card_title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-weight: bold;
                font-size: 16px;
                color: #333333;
                margin-bottom: 4px;
            }

            .card_conter {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
            }
        }

    }

}

.popular_title {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 33px;
}

.popular {
    padding-top: 132px;
    padding-bottom: 60px;
    height: 100%;
    background-image: url("../assets/img/bg2_left.png");
    background-repeat: no-repeat;
    background-size: 576px 458px;
    background-position: left top;

    .popular_new_box {
        min-width: 1200px;
        width: 1200px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .popular_new {
            width: 300px;
            height: 162px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 4px solid #ECEEF4;
            position: relative;
            cursor: pointer;
            .popular_name{
                width: 100%;
                position: absolute;
                display: flex;
                justify-content: center;
                bottom: 8px;
            }
            img {
                width: 115px;
                height: 112px;
            }

            &:hover {
                background: linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(232, 242, 255, 0.86) 100%);
                box-shadow: 0px 0 5px 0px #0050b52e;
            }
        }

        .popular_act {
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(232, 242, 255, 0.86) 100%);
            box-shadow: 0px 0 5px 0px #0050b52e;
            border-bottom: 4px solid #094990;

            &:before {
                position: absolute;
                content: "";
                width: 0;
                height: 0;
                left: 140px;
                bottom: -14px;
                border-top: solid 11px #094990;
                border-right: solid 10px transparent;
                border-left: solid 10px transparent;
            }
        }

    }

    .popular_list_data {
        min-width: 1200px;
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 20px auto;

        .popular_list_item {
            padding: 0 30px;
            margin-bottom: 10px;
            width: 44%;
            height: 88px;
            background: #F0F3F9;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .popular_list_item_title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #094990;
            }

            .popular_list_item_btn {
                width: 68px;
                height: 27px;
                background: #094990;
                border-radius: 4px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #FFFFFF;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
        }

        .no_expty {
            text-align: center;
            margin: auto;
            margin-top: 30px
        }
    }
}

.capacity {
    height: 594px;
    background: #EAEEF0;
    padding: 40xp 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .capacity_card {
        width: 1200px;
        height: 504px;
        background: #F8FBFF;
        display: flex;
        align-items: center;
        justify-content: center;
        // margin: auto;

        .capacity_left {
            margin-right: 49px;

            img {
                width: 400px;
                height: 372px;
            }
        }

        .capacity_right {
            display: flex;

            .step {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 400px;
                margin-right: 40px;

                .primary {
                    width: 8px;
                    height: 8px;
                    background: #EAEDF4;
                    border: 2px solid #FFFFFF;
                    border-radius: 100%;

                    &.act {
                        background: #094990;
                    }
                }

                .rectangle {
                    width: 2px;
                    height: 160px;
                    background: #EAEDF4;
                }
            }

            .right_list {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-content: space-between;

                .right_item {
                    display: flex;
                    align-items: center;
                    background-color: #FCFDFF;
                    padding: 15px 20px;

                    img {
                        width: 50px;
                        height: 45px;
                        margin-right: 15px;
                    }

                    &:hover {
                        background-color: #FFFFFF;
                        box-shadow: 0px 0 5px 0px #0050b52e;
                    }
                }

                .right_item_title {
                    font-weight: 400;
                    font-size: 16px;
                    color: #001D51;
                    margin-bottom: 5px;
                }

                .right_item_content {
                    font-weight: 400;
                    font-size: 12px;
                    color: #001D51;
                }
            }
        }
    }
}

.footer_box {
    background-color: #F8FBFF;

    .bg {
        background-image: url("../assets/img/bg2_left.png");
        background-repeat: no-repeat;
        background-size: 576px 433px;
        background-position: left;
        padding: 50px 0;
    }

    .select_list_box {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;

        .select_item {
            width: 393px;
            height: 119px;
            background: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            margin-bottom: 10px;
        }
    }
}
.footer_fout{
  position: fixed;
  bottom: 10%;
  right: 0;
}
</style>
<style>
::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}

::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    height: 20px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgb(139, 139, 139);
}

::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ffffff;
    display: none;
}
</style>